import { push } from 'react-router-redux';

import * as consts from './AppConsts';
import { getTourRequest, getBackgroundImageReq } from '../helpers/requestUtils';
import { setThemeClass } from '../helpers/index';
import * as notFoundActions from '../notFound/NotFoundActions';
import * as galleryActions from '../gallery/GalleryActions';
import * as listingsActions from '../listings/ListingsActions';
import * as mapActions from '../map/MapActions';

export const setUrlParams = (tourId, tourType) => {
    return dispatch => {
        dispatch({
            type: consts.SET_URL_PARAMS,
            payload: {
                tourId,
                tourType
            }
        })
    }
}

export const getTour = (tourId, tourType) => {
    return dispatch => {

        dispatch({
            type: consts.GET_TOUR_PENDING
        });

        return getTourRequest(tourId, tourType)
            .then(response => {
                if (!!+response.data.disabled) {
                    dispatch(notFoundActions.redirectToNotFound());
                    dispatch({
                        type: consts.GET_TOUR_REJECTED,
                        payload: {
                            getTourError: 'Order is disabled'
                        }
                    });
                    return;
                }

                if (!!+response.data.canceled) {
                    dispatch(notFoundActions.redirectToCanceled());
                    dispatch({
                        type: consts.GET_TOUR_REJECTED,
                        payload: {
                            getTourError: 'Order is canceled'
                        }
                    });
                    return;
                }

                const isDrafted = response.data.is_draft;
                const isLogined = response.data.is_logined;
                if (!isOrderProduced(isDrafted, isLogined)) {
                    dispatch(notFoundActions.redirectToNotProduced());
                    dispatch({
                        type: consts.GET_TOUR_REJECTED,
                        payload: {
                            getTourError: 'Order is not produced'
                        }
                    });
                    return;
                }
            dispatch({
                type: consts.GET_TOUR_FULFILLED,
                payload: response.data
            });
            dispatch(galleryActions.getGallery());
            dispatch(listingsActions.getListings());
            // set class of sps theme to body tag
            setThemeClass(response.data.sps_theme);
        }, error => {
            console.log(error);
            dispatch(notFoundActions.redirectToNotFound());
            dispatch({
                type: consts.GET_TOUR_REJECTED,
                payload: {
                    getTourError: error
                }
            });
        });
    }
}
/**
 * Saves information about the element that page should return to after user returns to home page from subpage
 * @param {object} element
 * @returns object
 */
export const savePosition = (element) => {
    return {
        type: consts.SAVE_POSITION,
        payload: element
    }
}
/**
 * Clears information about the element that page should return to after user returns to home page from subpage
 * @returns object
 */
export const clearPosition = () => {
    return {
        type: consts.CLEAR_POSITION
    }
}

export const getBackgroundPhoto = () => {
    return (dispatch, getState) => {
        const tourId = getState().app.tourId;

        dispatch({ type: consts.GET_BACKGROUND_PHOTO_PENDING });
        getBackgroundImageReq(tourId).then(data => {
            if (data.Error.length) {
                dispatch({ type: consts.GET_BACKGROUND_PHOTO_REJECTED });
            } else {
                dispatch({
                    type: consts.GET_BACKGROUND_PHOTO_FULFILLED,
                    payload: data.data
                });
            }
        }, () => {
            dispatch({type: consts.GET_BACKGROUND_PHOTO_REJECTED});
        });
    }
}

export const postMessageEvent = (values) => {
    const themes = ['traditional', 'cottage', 'estate', 'modern']
    if (values.theme ) {
        setThemeClass(values.theme);
    }
    
    return {
        type: consts.POST_MESSAGE_EVENT,
        payload: values
    }
} 

export const setContentBlur = (blurValue) => {
    return {
        type: consts.SET_CONTENT_BLUR,
        payload: blurValue
    }
}

export const redirectToHome = () => {
    return (dispatch, getState) => {
        const tourId = getState().app.tourId;
        const tourType = getState().app.tourType;
        dispatch(push(`/${tourId}/${tourType.charAt(0)}`));
    }
}

export const toggleFullscreen = (id) => {
    return (dispatch, getState) => {
        const isFullscreen = getState().app.isFullscreen;
        if (!isFullscreen) {
            const app = document.getElementById(id);
            if (app.requestFullscreen) {
                app.requestFullscreen();
            } else if (app.webkitRequestFullscreen) {
                app.webkitRequestFullscreen();
            } else if (app.mozRequestFullScreen) {
                app.mozRequestFullScreen();
            } else if (app.msRequestFullscreen) {
                app.msRequestFullscreen();
            }
        } else {
            if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if (document.webkitExitFullscreen) {
                document.webkitExitFullscreen();
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            } else if (document.msExitFullscreen) {
                document.msExitFullscreen();
            }
        }
        dispatch({
            type: consts.TOGGLE_FULLSCREEN,
            payload: !isFullscreen
        })
    }
}

/**
 * check if tour is in draft and user is not loggined in
 *
 * @param {bool} isDrafted order is in draft
 * @param {bool} isLogined user is loggined in
 * @returns {bool} order was produced
 */
const isOrderProduced = (isDrafted, isLogined) => {
    // if (isDrafted && !isLogined) {
    //     return false;
    // }
    return true;
}
